// Calendly integration utility with optimized loading
let calendlyLoaded = false
let calendlyLoadPromise: Promise<void> | null = null

export const loadCalendlyScript = (): Promise<void> => {
  if (calendlyLoaded) {
    return Promise.resolve()
  }

  if (calendlyLoadPromise) {
    return calendlyLoadPromise
  }

  calendlyLoadPromise = new Promise((resolve) => {
    // Check if script already exists
    if (document.querySelector('script[src*="calendly"]')) {
      calendlyLoaded = true
      resolve()
      return
    }

    const script = document.createElement('script')
    script.src = 'https://assets.calendly.com/assets/external/widget.js'
    script.async = true
    script.onload = () => {
      calendlyLoaded = true
      resolve()
    }
    document.head.appendChild(script)

    const link = document.createElement('link')
    link.href = 'https://assets.calendly.com/assets/external/widget.css'
    link.rel = 'stylesheet'
    document.head.appendChild(link)
  })

  return calendlyLoadPromise
}

export function openCalendlyPopup() {
  // Navigate to the dedicated demo booking page instead of opening popup
  window.location.href = '/kostenlose-demo'
}
